'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Pagination } from '@/lib/types/pageBuilder';
interface PaginationPanelProps {
  pagination: Pagination;
  currentPage: number;
  totalItems: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange?: (size: number) => void;
  loading?: boolean;
}
export default function PaginationPanel(t0) {
  const $ = _c(61);
  const {
    pagination,
    currentPage,
    totalItems,
    pageSize,
    onPageChange,
    onPageSizeChange,
    loading: t1
  } = t0;
  const loading = t1 === undefined ? false : t1;
  const totalPages = Math.min(Math.ceil(totalItems / pageSize), 500);
  let t2;
  if ($[0] !== pagination.pageSizeOptions) {
    t2 = pagination.pageSizeOptions || [10, 20, 50];
    $[0] = pagination.pageSizeOptions;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const pageSizeOptions = t2;
  let t3;
  if ($[2] !== currentPage || $[3] !== totalPages) {
    t3 = () => {
      const pages = [];
      if (totalPages <= 5) {
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        if (currentPage > 3) {
          pages.push("...");
        }
        const start = Math.max(2, currentPage - 1);
        const end = Math.min(totalPages - 1, currentPage + 1);
        for (let i_0 = start; i_0 <= end; i_0++) {
          pages.push(i_0);
        }
        if (currentPage < totalPages - 2) {
          pages.push("...");
        }
        if (totalPages > 1) {
          pages.push(totalPages);
        }
      }
      return pages;
    };
    $[2] = currentPage;
    $[3] = totalPages;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const getPageNumbers = t3;
  if (pagination.type === "numbered") {
    let t4;
    if ($[5] !== currentPage || $[6] !== onPageChange) {
      t4 = () => onPageChange(currentPage - 1);
      $[5] = currentPage;
      $[6] = onPageChange;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    const t5 = currentPage === 1 || loading;
    const t6 = `px-3 py-1.5 text-sm rounded ${currentPage === 1 || loading ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-white text-gray-700 hover:bg-gray-50"}`;
    let t7;
    if ($[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
      t7 = <button onClick={t4} disabled={t5} className={t6}>முந்தைய</button>;
      $[8] = t4;
      $[9] = t5;
      $[10] = t6;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    let t8;
    if ($[12] !== getPageNumbers) {
      t8 = getPageNumbers();
      $[12] = getPageNumbers;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    let t9;
    if ($[14] !== currentPage || $[15] !== loading || $[16] !== onPageChange || $[17] !== t8) {
      t9 = <div className="flex items-center gap-1">{t8.map((page, index) => <button key={index} onClick={() => typeof page === "number" && onPageChange(page)} disabled={page === "..." || page === currentPage || loading} className={`min-w-[32px] h-8 px-2 text-sm rounded ${page === currentPage ? "bg-[#215EF9] text-white" : page === "..." ? "cursor-default" : "bg-white text-gray-700 hover:bg-gray-50"}`}>{page}</button>)}</div>;
      $[14] = currentPage;
      $[15] = loading;
      $[16] = onPageChange;
      $[17] = t8;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] !== currentPage || $[20] !== onPageChange) {
      t10 = () => onPageChange(currentPage + 1);
      $[19] = currentPage;
      $[20] = onPageChange;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    const t11 = currentPage === totalPages || loading;
    const t12 = `px-3 py-1.5 text-sm rounded ${currentPage === totalPages || loading ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-white text-gray-700 hover:bg-gray-50"}`;
    let t13;
    if ($[22] !== t10 || $[23] !== t11 || $[24] !== t12) {
      t13 = <button onClick={t10} disabled={t11} className={t12}>அடுத்து</button>;
      $[22] = t10;
      $[23] = t11;
      $[24] = t12;
      $[25] = t13;
    } else {
      t13 = $[25];
    }
    let t14;
    if ($[26] !== loading || $[27] !== onPageSizeChange || $[28] !== pageSize || $[29] !== pageSizeOptions || $[30] !== pagination.showSizeChanger) {
      t14 = pagination.showSizeChanger && onPageSizeChange && <select value={pageSize} onChange={e => onPageSizeChange(Number(e.target.value))} disabled={loading} className="ml-4 px-2 py-1.5 text-sm rounded bg-white">{pageSizeOptions.map(_temp)}</select>;
      $[26] = loading;
      $[27] = onPageSizeChange;
      $[28] = pageSize;
      $[29] = pageSizeOptions;
      $[30] = pagination.showSizeChanger;
      $[31] = t14;
    } else {
      t14 = $[31];
    }
    let t15;
    if ($[32] !== pagination.showTotal || $[33] !== totalItems) {
      t15 = pagination.showTotal && <span className="ml-4 text-sm text-gray-500">மொத்தம்: {totalItems}</span>;
      $[32] = pagination.showTotal;
      $[33] = totalItems;
      $[34] = t15;
    } else {
      t15 = $[34];
    }
    let t16;
    if ($[35] !== loading) {
      t16 = loading && <span className="ml-2 text-sm text-gray-400">Loading...</span>;
      $[35] = loading;
      $[36] = t16;
    } else {
      t16 = $[36];
    }
    let t17;
    if ($[37] !== t13 || $[38] !== t14 || $[39] !== t15 || $[40] !== t16 || $[41] !== t7 || $[42] !== t9) {
      t17 = <div className="pagination-panel flex items-center justify-center gap-2 py-4">{t7}{t9}{t13}{t14}{t15}{t16}</div>;
      $[37] = t13;
      $[38] = t14;
      $[39] = t15;
      $[40] = t16;
      $[41] = t7;
      $[42] = t9;
      $[43] = t17;
    } else {
      t17 = $[43];
    }
    return t17;
  }
  if (pagination.type === "loadmore") {
    const hasMore = currentPage < totalPages;
    let t4;
    if ($[44] !== currentPage || $[45] !== hasMore || $[46] !== loading || $[47] !== onPageChange) {
      t4 = hasMore && <button onClick={() => onPageChange(currentPage + 1)} disabled={loading} className={`px-6 py-2 text-sm rounded ${loading ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-[#215EF9] text-white hover:bg-[#1a4bc7]"}`}>{loading ? "Loading..." : "\u0BAE\u0BC7\u0BB2\u0BC1\u0BAE\u0BCD \u0B95\u0BBE\u0B9F\u0BCD\u0B9F\u0BC1"}</button>;
      $[44] = currentPage;
      $[45] = hasMore;
      $[46] = loading;
      $[47] = onPageChange;
      $[48] = t4;
    } else {
      t4 = $[48];
    }
    let t5;
    if ($[49] !== currentPage || $[50] !== pageSize || $[51] !== pagination.showTotal || $[52] !== totalItems) {
      t5 = pagination.showTotal && <span className="ml-4 text-sm text-gray-500 self-center">{Math.min(currentPage * pageSize, totalItems)} / {totalItems}</span>;
      $[49] = currentPage;
      $[50] = pageSize;
      $[51] = pagination.showTotal;
      $[52] = totalItems;
      $[53] = t5;
    } else {
      t5 = $[53];
    }
    let t6;
    if ($[54] !== t4 || $[55] !== t5) {
      t6 = <div className="pagination-panel flex justify-center py-4">{t4}{t5}</div>;
      $[54] = t4;
      $[55] = t5;
      $[56] = t6;
    } else {
      t6 = $[56];
    }
    return t6;
  }
  if (pagination.type === "infinite") {
    let t4;
    if ($[57] !== loading) {
      t4 = loading && <div className="flex justify-center"><span className="text-sm text-gray-400">Loading...</span></div>;
      $[57] = loading;
      $[58] = t4;
    } else {
      t4 = $[58];
    }
    let t5;
    if ($[59] !== t4) {
      t5 = <div className="pagination-panel py-4">{t4}</div>;
      $[59] = t4;
      $[60] = t5;
    } else {
      t5 = $[60];
    }
    return t5;
  }
  return null;
}
function _temp(size) {
  return <option key={size} value={size}>{size} / பக்கம்</option>;
}